import { render } from "./XmlEditor.vue?vue&type=template&id=2621cb4f&scoped=true"
import script from "./XmlEditor.vue?vue&type=script&lang=js"
export * from "./XmlEditor.vue?vue&type=script&lang=js"

import "./XmlEditor.vue?vue&type=style&index=0&id=2621cb4f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2621cb4f"]])

export default __exports__